import { Component, Input } from '@angular/core';

@Component({
    selector: 'flow-tool-bubble',
    template: `
        <div class="message-row justify-start">
            <div class="message-bubble assistant">
                <div class="message-header">
                    <div class="message-sender-info">
                        <gf-glyph class="glyph-img-gforge-flow message-flow-glyph"></gf-glyph>
                        <span class="message-sender">Flow AI</span>
                    </div>
                </div>
                <div class="tool-bubble-body">
                    <flow-thinking-indicator></flow-thinking-indicator>
                    <span class="tool-bubble-label">{{ label }}</span>
                </div>
            </div>
        </div>
    `,
    styles: [`
        :host { display: block; }
        .message-row {
            display: flex;
            margin-bottom: 20px;
        }
        .message-bubble {
            min-width: max(30%, 220px);
            max-width: 90%;
            border-radius: 5px;
            padding: 12px 16px;
            background-color: #f5f5f5;
        }
        .message-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        }
        .message-sender-info {
            display: flex;
            align-items: center;
            gap: 7px;
        }
        .message-flow-glyph {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 22px;
            height: 22px;
            flex-shrink: 0;
        }
        .message-flow-glyph ::ng-deep svg {
            width: 22px;
            height: 22px;
        }
        .message-sender {
            font-weight: bold;
            font-size: 14px;
            color: #444;
        }
        .tool-bubble-body {
            display: flex;
            align-items: center;
            gap: 10px;
        }
        .tool-bubble-label {
            font-size: 13px;
            color: #666;
            font-style: italic;
        }
    `]
})
export class ToolBubbleComponent {
    @Input() label: string = '';
}
